import { UPDATE_TAB_NAME } from '../actions/current-tab';

const initialState = 'adminUsers';

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_TAB_NAME:
      return action.tabName || initialState;
    default:
      return state;
  }
}
